import Select from 'react-select';
import { COLORS } from '../../theme';
import { WHITE_LABEL_ACCENT_COLOR } from '../../lib/white-label';

type StyleProps = {
  width: string | number;
  minWidth: string | number;
};
const selectStyles = ({ width, minWidth }: StyleProps) => {
  return {
    control: (provided, state) => ({
      ...provided,
      background: '#F6F9FC 0% 0% no-repeat padding-box',
      border: '1px solid #E5E8F0',
      borderRadius: '10px',
      height: '100%',
      minWidth: minWidth || 'auto',
      boxShadow: state.isFocused
        ? `0 0 0 1px ${WHITE_LABEL_ACCENT_COLOR}`
        : 'none',
      borderColor: state.isFocused ? WHITE_LABEL_ACCENT_COLOR : '#E5E8F0',
      ':hover': {
        borderColor: WHITE_LABEL_ACCENT_COLOR,
      },
    }),
    menu: (provided) => ({
      ...provided,
      background: '#F6F9FC 0% 0% no-repeat padding-box',
      border: '1px solid #E2E3E3',
      color: COLORS.GRAY,
      marginTop: 0,
      minWidth: minWidth || 'auto',
    }),
    clearIndicator: (provided) => ({
      ...provided,
      paddingRight: '.1rem',
      paddingLeft: '.1rem',
      cursor: 'pointer',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      paddingLeft: '.1rem',
      cursor: 'pointer',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#A1A3AC',
      font: 'normal normal 500 .875rem/21px Poppins',
      letterSpacing: 0.44,
    }),
    input: (provided) => ({
      ...provided,
      color: COLORS.GRAY,
      font: 'normal normal 500 1rem/21px Poppins',
      outline: 'none',
      boxShadow: 'none',
      '& > input': {
        outline: 'none !important',
        boxShadow: 'none !important',
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: COLORS.GRAY,
      font: 'normal normal 500 .875rem/21px Poppins',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? WHITE_LABEL_ACCENT_COLOR : '',
    }),
  };
};

const FilterSelect = (props) => {
  return (
    <Select
      className="w-full h-full"
      styles={selectStyles(props)}
      {...props}
      instanceId={props.instanceId}
    />
  );
};

export default FilterSelect;
